import React, { useEffect, useState } from 'react';
import styles from './Header.module.scss';
import clsx from 'clsx';
import { TELEGRAM_CTA_URL } from '../../constants/cta';
import { HEADER_SECTIONS } from '../../constants/marketingContent';
import { trackGoal } from '../../analytics/metrika';
import logoIcon from '../../assets/images/logo-6.png';

const Header = () => {
  const [activeSection, setActiveSection] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToWithOffset = (element, offset = 0) => {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  };

  const handleScroll = () => {
    const contactCard = document.getElementById('contact-card');
    if (contactCard) {
      const contactCardRect = contactCard.getBoundingClientRect();
      const isContactCardVisible = contactCardRect.top < window.innerHeight - 80 && contactCardRect.bottom > 120;

      if (isContactCardVisible) {
        setActiveSection((prev) => (prev === 'contact' ? prev : 'contact'));
        return;
      }
    }

    const scrollY = window.scrollY + 120;
    let nextActiveSection = '';

    HEADER_SECTIONS.forEach((section) => {
      const element = document.getElementById(section.id);
      if (!element) {
        return;
      }

      const offsetTop = element.offsetTop;
      const height = element.offsetHeight;

      if (scrollY >= offsetTop && scrollY < offsetTop + height) {
        nextActiveSection = section.id;
      }
    });

    setActiveSection((prev) => (prev === nextActiveSection ? prev : nextActiveSection));
  };

  const handleClick = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      scrollToWithOffset(element, 70);
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 860) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const openTelegram = () => {
    trackGoal('cta_telegram_click', { source: 'header' });
    window.open(TELEGRAM_CTA_URL, '_blank');
  };

  return (
    <div className={clsx(styles.header)}>
      <div className="container">
        <div className={clsx(styles.inner)}>
          <div className={clsx(styles.content)}>
            <div className={clsx(styles.logo)}>
              <img src={'/img-webp/logo-6.webp'} alt="Логотип" className={clsx(styles.logoIcon)} />
              <img src="/img-webp/logo2.svg" alt="Даниил" className={clsx(styles.logoText)} />
            </div>

            <nav className={clsx(styles.menu, styles.menuHeader)}>
              {HEADER_SECTIONS.map((item) => (
                <a href={`#${item.id}`} key={item.id} className={clsx(styles.menuItem, activeSection === item.id && styles.menuItemActive)} onClick={(e) => handleClick(e, item.id)}>
                  {item.label}
                </a>
              ))}
            </nav>

            <div className={clsx(styles.rightActions)}>
              <button className={clsx(styles.btn)} onClick={openTelegram} data-metrika-label="Ответ до 15 минут" data-metrika-section="header">
                <span className={styles.btnTextDesktop}>Ответ до 15 минут</span>
                <span className={styles.btnTextMobile}>Ответ до 15 мин</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                    <path d="M10 2h4m-2 12l3-3" />
                    <circle cx="12" cy="14" r="8" />
                  </g>
                </svg>
              </button>
              <button
                type="button"
                className={clsx(styles.burger)}
                onClick={() => {
                  setIsMenuOpen((prev) => !prev);
                }}
                aria-label={isMenuOpen ? 'Закрыть меню' : 'Открыть меню'}
                aria-expanded={isMenuOpen}
                aria-controls="mobile-menu">
                {isMenuOpen ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={clsx(styles.burgerIcon)}>
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" className={clsx(styles.burgerIcon)}>
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 5h16M4 12h16M4 19h16" />
                  </svg>
                )}
              </button>
            </div>

            <nav id="mobile-menu" className={clsx(styles.mobileMenu, isMenuOpen && styles.mobileMenuOpen)}>
              {HEADER_SECTIONS.map((item) => (
                <a href={`#${item.id}`} key={item.id} className={clsx(styles.mobileMenuItem, activeSection === item.id && styles.mobileMenuItemActive)} onClick={(e) => handleClick(e, item.id)}>
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
